// Re-export shim → @owlcat/ui shared baseline. Portal's Button was byte-identical
// (bar the cn import path); @owlcat/ui adds additive icon-sm/icon-lg sizes.
// Import path preserved so all @/shared/components/ui/button call sites are unchanged.
export { Button } from "@owlcat/ui"
